module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABGdBTUEAALGPC/xhBQAAAGtJREFUOBFjPHDt7/+ebYwMrz4xMpADxPj+M5R4/Wdg8On59//orf9kgyNAvSAzmEAusVIlxy0QPdZAvSAzmMg3AlXnqEGo4YGNNxpG2EIFVWw0jFDDAxuPCVSeHL2NTYo4MZBekBmM1CrYALP5Ye8Ebdt2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/all_icon_checkbox_default.png
// module id = 8BJw
// module chunks = 1